export const ERROR_471 = "471";
export const FREE_PLAN_ERROR = "SUB_01";

export const messageErrorCodes = [ERROR_471, FREE_PLAN_ERROR];